module.exports = __webpack_public_path__ + "static/media/Plymouth-Village-First-Amendment-to-Master-Deed.83615307.pdf";